// import React, { useEffect } from 'react';
// import {
//   Box,
//   TextField,
//   IconButton
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import colors from '../theme/Colors';

// const OrderItemsTable = ({ items, handleItemChange, handleRemoveItem, formIndex }) => {
//   const sizeGroups = {
//     S: ["6M", "2Y"],
//     M: ["12M", "4Y"],
//     L: ["12M", "6Y"],
//   };
//   const sizeOptions = ['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'];
//   useEffect(()=>{console.log("items:",{items,formIndex})},[items]);
//   return (
//     <Box>
//       {/* <Box sx={{
//         display: 'flex',
//         gap: 1,
//         mb: 1,
//         backgroundColor: colors.primary,
//         p: 1,
//         textAlign: 'center',
//         borderRadius: '4px 4px 0 0',
//         '& > div': {
//           color: 'black',
//           fontWeight: 500,
//           fontSize: '0.9rem',
//           width: '8%'
//         }
//       }}>
//         <Box sx={{ width: '10%' }}>Color</Box>
//         {sizeOptions.map((size) => (
//           <Box key={size}>{size}</Box>
//         ))}
        
//         <Box>Available</Box>
//         <Box>Price</Box>
//         <Box>Total</Box>
//         <Box sx={{ width: '5%' }}>Action</Box>
//       </Box> */}
// <Box
//   sx={{
//     display: "flex",
//     mb: 1,
//     backgroundColor: colors.primary,
//     p: 1,
//     textAlign: "center",
//     borderRadius: "4px 4px 0 0",
//     "& > div": {
//       color: "black",
//       fontWeight: 500,
//       fontSize: "0.9rem",
//       border: "1px solid black",
//     },
//   }}
// >
//   {/* Color column */}
//   <Box
//     sx={{
//       width: "10%",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//     }}
//   >
//     Color
//   </Box>

//   {/* Sizes */}
//   {sizeOptions.map((size) =>
//     sizeGroups[size] ? (
//       <Box
//         key={size}
//         sx={{
//           flex: 1,
//           display: "flex",
//           minWidth:"100px",
//           flexDirection: "column",
//         }}
//       >
//         {/* Parent label */}
        
//         {/* Sub-labels */}
//         <Box sx={{ display: "flex" }}>
//           {sizeGroups[size].map((child, idx) => (
//             <Box
//               key={child}
//               sx={{
//                 flex: 1,
//                 borderRight: idx === 0 ? "1px solid black" : "none",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 minHeight: "30px",
//               }}
//             >
//               {child}
//             </Box>
//           ))}
//         </Box>
//         <Box
//           sx={{
//             borderBottom: "1px solid black",
//             borderTop: "1px solid black",

//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             minHeight: "30px",
//           }}
//         >
//           {size==='S'?'Small':size==='M'?'Medium':size==='L'?'Large':size}
//         </Box>
//       </Box>
//     ) : (
//       <Box
//         key={size}
//         sx={{
//           width: "8%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {size}
//       </Box>
//     )
//   )}

//   {/* Remaining columns */}
//   <Box sx={{ width: "10%", display: "flex", justifyContent: "center", alignItems: "center" }}>
//     Available
//   </Box>
//   <Box sx={{ width: "10%", display: "flex", justifyContent: "center", alignItems: "center" }}>
//     Price
//   </Box>
//   <Box sx={{ width: "10%", display: "flex", justifyContent: "center", alignItems: "center" }}>
//     Total
//   </Box>
//   <Box sx={{ width: "5%", display: "flex", justifyContent: "center", alignItems: "center" }}>
//     Action
//   </Box>
// </Box>
//       <Box sx={{
//         border: '1px solid #e0e0e0',
//         borderRadius: '0 0 4px 4px',
//         backgroundColor: '#f8f8f8',
//         p: 1
//       }}>
//         {items.map((item, index) => (
//           <Box key={index} sx={{
//             display: 'flex',
//             gap: 1,
//             mb: 0.5,
//             alignItems: 'center',
//             '& .MuiTextField-root': {
//               backgroundColor: 'white',
//             }
//           }}>
//             <TextField
//               label="Color"
//               value={item.color}
//               disabled
//               sx={{ width: '10%' }}
//             />
//             {sizeOptions.map((sizeOption,index) => (
//               <TextField
//                 key={sizeOption}
//                 label={`${sizeOption} (${item[`${sizeOption}_in_hand`] || 0})`}
//                 type="number"
//                 value={item[sizeOption] || ''}
//                 onChange={(e) => handleItemChange(index, sizeOption, e.target.value)}
//                 error={item[sizeOption] > item[`${sizeOption}_in_hand`]}
//                 sx={{ width: '8%' }}
//                 InputProps={{
//                   inputProps: {
//                     min: 0,
//                     max: item[`${sizeOption}_in_hand`] || 999999
//                   }
//                 }}
//               />
//             ))}
//             <TextField
//               type="number"
//               value={item.quantity_in_hand || 0}
//               InputProps={{
//                 readOnly: true,
//               }}
//               sx={{ width: '8%' }}
//             />
//             <TextField
//               type="number"
//               value={item.price || ''}
//               InputProps={{
//                 readOnly: true,
//               }}
//               sx={{ width: '8%' }}
//             />
//             <TextField
//               type="number"
//               value={item.total || ''}
//               InputProps={{
//                 readOnly: true,
//               }}
//               sx={{ width: '8%' }}
//             />
//             <IconButton
//               onClick={() => handleRemoveItem(formIndex, index)}
//               sx={{ width: '5%' }}
//             >
//               <DeleteIcon />
//             </IconButton>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default OrderItemsTable; 
// import React, { useEffect } from 'react';
// import {
//   Box,
//   TextField,
//   IconButton
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import colors from '../theme/Colors';

// const OrderItemsTable = ({ items, handleItemChange, handleRemoveItem, formIndex }) => {
//   const sizeGroups = {
//     S: ["6M", "2Y"],
//     M: ["12M", "4Y"],
//     L: ["12M", "6Y"],
//   };

//   const sizeOptions = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'];

//   useEffect(() => {
//     console.log("items:", { items, formIndex });
//   }, [items, formIndex]);

//   return (
//     <Box sx={{ overflowX: "auto" }}>
//       {/* Header row */}
//       <Box
//         sx={{
//           display: "flex",
//           minWidth: "1300px", // ensures scroll on small screens
//           mb: 1,
//           backgroundColor: colors.primary,
//           p: 1,
//           textAlign: "center",
//           borderRadius: "4px 4px 0 0",
//           "& > div": {
//             color: "black",
//             fontWeight: 500,
//             fontSize: "0.9rem",
//             border: "1px solid black",
//           },
//         }}
//       >
//         {/* Color column */}
//         <Box
//           sx={{
//             flex: 1,
//             minWidth: "120px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           Color
//         </Box>

//         {/* Sizes */}
//         {sizeOptions.map((size) =>
//           sizeGroups[size] ? (
//             <Box
//               key={size}
//               sx={{
//                 flex: 1,
//                 minWidth: "110px",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <Box sx={{ display: "flex" }}>
//                 {sizeGroups[size].map((child, idx) => (
//                   <Box
//                     key={child}
//                     sx={{
//                       flex: 1,
//                       borderRight: idx === 0 ? "1px solid black" : "none",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       minHeight: "30px",
//                     }}
//                   >
//                     {child}
//                   </Box>
//                 ))}
//               </Box>
//               <Box
//                 sx={{
//                   borderBottom: "1px solid black",
//                   borderTop: "1px solid black",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   minHeight: "30px",
//                 }}
//               >
//                 {size === 'S' ? 'Small' : size === 'M' ? 'Medium' : size === 'L' ? 'Large' : size}
//               </Box>
//             </Box>
//           ) : (
//             <Box
//               key={size}
//               sx={{
//                 flex: 1,
//                 minWidth: "100px",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {size}
//             </Box>
//           )
//         )}

//         {/* Remaining columns */}
//         <Box sx={{ flex: 1, minWidth: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           Available
//         </Box>
//         <Box sx={{ flex: 1, minWidth: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           Price
//         </Box>
//         <Box sx={{ flex: 1, minWidth: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           Total
//         </Box>
//         <Box sx={{ width: "80px", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           Action
//         </Box>
//       </Box>

//       {/* Table body */}
//       <Box
//         sx={{
//           border: '1px solid #e0e0e0',
//           borderRadius: '0 0 4px 4px',
//           backgroundColor: '#f8f8f8',
//           p: 1,
//           minWidth: "1200px", // matches header
//         }}
//       >
//         {items.map((item, itemIndex) => (
//           <Box
//             key={`item-${formIndex}-${item.stockId}`}
//             sx={{
//               display: 'flex',
//               gap: 1,
//               mb: 0.5,
//               alignItems: 'center',
//               '& .MuiTextField-root': {
//                 backgroundColor: 'white',
//               }
//             }}
//           >
//             {/* Color column */}
//             <TextField
//               label="Color"
//               value={item.color}
//               disabled
//               sx={{ flex: 1, minWidth: "120px" }}
//             />

//             {/* Size inputs */}
//             {sizeOptions.map((sizeOption) => (
//               <TextField
//                 key={`${item.stockId}-${sizeOption}`}
//                 label={`${sizeOption} (${item[`${sizeOption}_in_hand`] || 0})`}
//                 type="number"
//                 value={item[sizeOption] || ''}
//                 onChange={(e) => handleItemChange(itemIndex, sizeOption, e.target.value)}
//                 error={item[sizeOption] > item[`${sizeOption}_in_hand`]}
//                 sx={{ flex: 1, minWidth: "100px" }}
//                 InputProps={{
//                   inputProps: {
//                     min: 0,
//                     max: item[`${sizeOption}_in_hand`] || 999999
//                   }
//                 }}
//               />
//             ))}

//             {/* Available */}
//             <TextField
//               type="number"
//               value={item.quantity_in_hand || 0}
//               InputProps={{ readOnly: true }}
//               sx={{ flex: 1, minWidth: "120px" }}
//             />

//             {/* Price */}
//             <TextField
//               type="number"
//               value={item.price || ''}
//               InputProps={{ readOnly: true }}
//               sx={{ flex: 1, minWidth: "120px" }}
//             />

//             {/* Total */}
//             <TextField
//               type="number"
//               value={item.total || ''}
//               InputProps={{ readOnly: true }}
//               sx={{ flex: 1, minWidth: "120px" }}
//             />

//             {/* Delete button */}
//             <IconButton
//               onClick={() => handleRemoveItem(formIndex, itemIndex)}
//               sx={{ width: "80px" }}
//             >
//               <DeleteIcon />
//             </IconButton>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default OrderItemsTable;
import React, { useEffect } from 'react';
import {
  Box,
  TextField,
  IconButton,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import colors from '../theme/Colors';

// Helper component for nested headers
const NestedHeader = ({ parent, children, isLast = false }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `repeat(${children.length}, 1fr)`,
      borderRight: isLast ? 'none' : '1px solid black',
    }}
  >
    <Box
      sx={{
        gridColumn: `span ${children.length}`,
        borderBottom: '1px solid black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '30px',
        fontWeight: 'bold',
      }}
    >
      {parent}
    </Box>
    {children.map((child, idx) => (
      <Box
        key={child}
        sx={{
          borderRight: idx === children.length - 1 ? 'none' : '1px solid black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '30px',
        }}
      >
        {child}
      </Box>
    ))}
  </Box>
);

const OrderItemsTable = ({ items, handleItemChange, handleRemoveItem, formIndex }) => {
  const sizeGroups = {
    S: ["6M", "2Y"],
    M: ["12M", "4Y"],
    L: ["12M", "6Y"],
  };

  const sizeOptions = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'];

  useEffect(() => {
    console.log("items:", { items, formIndex });
  }, [items, formIndex]);

  // Define grid template columns
  const gridTemplate = `120px repeat(${sizeOptions.length}, 1fr) 120px 120px 120px 80px`;

  return (
    <Box sx={{ overflowX: 'auto', p: 1 }}>
      {/* Header row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: gridTemplate,
          minWidth: '1300px',
          backgroundColor: colors.primary,
          textAlign: 'center',
          borderRadius: '4px 4px 0 0',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        {/* Color column */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRight: '1px solid black',
            fontWeight: 'bold',
            p: 1,
          }}
        >
          Color
        </Box>

        {/* Sizes */}
        {sizeOptions.map((size, index) =>
          sizeGroups[size] ? (
            <NestedHeader
              key={size}
              parent={size === 'S' ? 'Small' : size === 'M' ? 'Medium' : 'Large'}
              children={sizeGroups[size]}
              isLast={index === sizeOptions.length - 1}
            />
          ) : (
            <Box
              key={size}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRight: '1px solid black',
                fontWeight: 'bold',
                p: 1,
              }}
            >
              {size}
            </Box>
          )
        )}

        {/* Remaining columns */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid black', fontWeight: 'bold', p: 1 }}>
          Available
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid black', fontWeight: 'bold', p: 1 }}>
          Price
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid black', fontWeight: 'bold', p: 1 }}>
          Total
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', p: 1 }}>
          Action
        </Box>
      </Box>

      {/* Table body */}
      <Box
        sx={{
          minWidth: '1300px',
          border: '1px solid #e0e0e0',
          borderRadius: '0 0 4px 4px',
          backgroundColor: '#f8f8f8',
        }}
      >
        {items.map((item, itemIndex) => (
          <Box
            key={`item-${formIndex}-${item.stockId}`}
            sx={{
              display: 'grid',
              gridTemplateColumns: gridTemplate,
              alignItems: 'center',
              '& > .MuiTextField-root': {
                backgroundColor: 'white',
                mx: '4px',
                my: '4px',
              },
            }}
          >
            {/* Color column */}
            <TextField
              label="Color"
              value={item.color}
              disabled
              sx={{
                gridColumn: '1',
              }}
            />

            {/* Size inputs */}
            {sizeOptions.map((sizeOption) => (
              <TextField
                key={`${item.stockId}-${sizeOption}`}
                label={`${sizeOption} (${item[`${sizeOption}_in_hand`] || 0})`}
                type="number"
                value={item[sizeOption] || ''}
                onChange={(e) => handleItemChange(itemIndex, sizeOption, e.target.value)}
                error={item[sizeOption] > item[`${sizeOption}_in_hand`]}
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: item[`${sizeOption}_in_hand`] || 999999,
                  },
                }}
              />
            ))}

            {/* Available, Price, Total */}
            <TextField
              label="Available"
              type="number"
              value={item.quantity_in_hand || 0}
              InputProps={{ readOnly: true }}
            />
            <TextField
              label="Price"
              type="number"
              value={item.price || ''}
              InputProps={{ readOnly: true }}
            />
            <TextField
              label="Total"
              type="number"
              value={item.total || ''}
              InputProps={{ readOnly: true }}
            />

            {/* Delete button */}
            <Box
              sx={{
                gridColumn: `${sizeOptions.length + 5}`,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <IconButton onClick={() => handleRemoveItem(formIndex, itemIndex)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default OrderItemsTable;
